import { SegmentItem, Wrapper } from './MultiSegmentProgressCompat.styles';

export interface Segment {
  id: string;
  percentage: number;
  color: string;
  label?: string;
}

interface MultiSegmentProgressProps {
  segments: Segment[];
  height?: number;
  showTooltips?: boolean;
  backgroundColor?: string;
  borderRadius?: number;
}

const clamp = (value: number) => Math.max(0, Math.min(value, 100));

export const MultiSegmentProgress: React.FC<MultiSegmentProgressProps> = ({
  segments,
  height = 10,
  showTooltips = false,
  backgroundColor = '#f0f0f0',
  borderRadius = 0
}) => {
  const normalizedSegments = segments
    .map(segment => ({
      ...segment,
      percentage: clamp(segment.percentage)
    }))
    .filter(segment => segment.percentage > 0);

  return (
    <Wrapper $height={height} $backgroundColor={backgroundColor} $borderRadius={borderRadius}>
      {normalizedSegments.map(segment => (
        <SegmentItem
          key={segment.id}
          $width={segment.percentage}
          $color={segment.color}
          title={showTooltips ? segment.label : undefined}
        />
      ))}
    </Wrapper>
  );
};
